// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"a5de7724","453":"bd27a2e6"}[chunkId] + ".chunk.js";
};